<div pmdModal
    modalTrap
    class="modal pmd-modal fade"
    tabindex="-1"
    role="dialog"
    aria-labelledby="vertically-centered"
    [config]="{ backdrop: 'static' }">
    <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content profile-setup-modal-content">
            <div class="profile-setup-modal-header d-flex justify-content-end align-items-center p-3 p-lg-4">
                <button type="button" class="btn btn-link logout-link d-flex align-items-center gap-2" (click)="onLogout()">
                    <svg width="18" height="16" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0.833496 7C0.833496 3.42825 3.62631 0.500239 7.11084 0.5C8.11387 0.5 9.0629 0.743736 9.90381 1.17676L10.2573 1.37402L10.3384 1.43457C10.5099 1.59183 10.5537 1.8533 10.4292 2.06055C10.3048 2.26756 10.0537 2.3517 9.83447 2.27441L9.74268 2.23145L9.44678 2.06641C8.74249 1.70355 7.94953 1.5 7.11084 1.5C4.21382 1.50024 1.8335 3.94463 1.8335 7C1.8335 10.0554 4.21382 12.4998 7.11084 12.5C8.06918 12.5 8.96765 12.2341 9.74268 11.7686L9.83447 11.7256C10.0537 11.6483 10.3048 11.7324 10.4292 11.9395C10.5714 12.1762 10.494 12.4838 10.2573 12.626L9.90381 12.8232C9.06291 13.2563 8.11387 13.5 7.11084 13.5C3.62631 13.4998 0.833496 10.5717 0.833496 7ZM11.647 3.97949C11.8178 3.80896 12.081 3.78806 12.2749 3.91602L12.354 3.97949L15.02 6.64648C15.2153 6.84174 15.2153 7.15825 15.02 7.35352L12.354 10.0205C12.1588 10.2157 11.8423 10.2155 11.647 10.0205C11.4517 9.82525 11.4517 9.50874 11.647 9.31348L13.4595 7.5H6.00049C5.72435 7.5 5.50049 7.27614 5.50049 7C5.50049 6.72386 5.72435 6.5 6.00049 6.5H13.4595L11.647 4.68652L11.5825 4.6084C11.4544 4.41433 11.4761 4.15033 11.647 3.97949Z" fill="black" />
                    </svg>
                    Logout
                </button>
            </div>
            <!-- Modal Body -->
            <div class="modal-body p-0 m-0">
                <div class="row g-0">
                    <div class="col-md-4">
                        <div class="bg-light-gray h-100 rounded-0 border-end p-3 p-lg-4">
                            <p class="text-desc">Complete following steps to setup your profile</p>
                            <div class="khar_wizard">
                                <div class="process py-4">
                                    <ul>
                                        <li class="step {{currentStep == 1 ? 'current' : 'completed'}}">
                                            <div class="name">Personal Info
                                            </div>
                                            <p class="subtitle">Your basic details</p>
                                        </li>
                                        <li
                                            class="step {{currentStep == 2 ? 'current' : ''}}">
                                            <div class="name">Company Info</div>
                                            <p class="subtitle">Your Company details</p>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-8">
                        <form action="#"
                            class="p-3 p-lg-4  pb-lg-3">
                            <div class="personal-info-card"
                                *ngIf="currentStep == 1">
                                <form [formGroup]="personalInfoFormGroup">
                                    <div class="text-secondary-dark fw-bold">Step 1 of 2</div>
                                    <h4 class="text-dark">Personal Info</h4>
                                    <div class="mb-3 mt-4">
                                        <label for="userName"
                                            class="col-form-label">Owner Name <strong class="text-danger">*</strong>
                                        </label>
                                        <pmd-textfield pmd-textfield-outline>
                                            <input name="userName"
                                                formControlName="name"
                                                id="userName"
                                                maxlength="100"
                                                type="text"
                                                class="form-control"
                                                placeholder="Rohan Patel"
                                                pmdTextField
                                                autocomplete="off">
                                        </pmd-textfield>
                                        <div *ngIf="sharedService.hasErrors(fPersonalInfo.name, isSubmitAttemptedForPersonalInfo)"
                                            class="invalid-feedback">
                                            <ng-container *ngIf="fPersonalInfo.name.errors.required">
                                                Owner Name is required.
                                            </ng-container>
                                            <ng-container *ngIf="fPersonalInfo.name.errors.pattern">
                                                Enter a valid Owner Name.
                                            </ng-container>
                                        </div>
                                    </div>
                                    <div class="mb-3">
                                        <label for="email"
                                            class="col-form-label">Email <strong class="text-danger">*</strong>
                                        </label>
                                        <pmd-textfield pmd-textfield-outline>
                                            <input name="email"
                                                formControlName="email"
                                                id="email"
                                                maxlength="100"
                                                type="text"
                                                class="form-control"
                                                pmdTextField
                                                placeholder="rohanpatel@gmail.com"
                                                autocomplete="off"
                                                (keydown)="fPersonalInfo.email.disabled ? $event.preventDefault() : ''" />
                                        </pmd-textfield>
                                        <div *ngIf="sharedService.hasErrors(fPersonalInfo.email, isSubmitAttemptedForPersonalInfo)"
                                            class="invalid-feedback">
                                            <ng-container
                                                *ngIf="fPersonalInfo.email.errors.required || fPersonalInfo.email.errors.pattern">
                                                Enter a valid email id.
                                            </ng-container>
                                        </div>
                                    </div>
                                    <div class="mb-3">
                                        <label for="mobile"
                                            class="col-form-label">Mobile Number <strong class="text-danger">*</strong>
                                        </label>
                                        <pmd-textfield pmd-textfield-outline>
                                            <input name="mobile"
                                                formControlName="mobile"
                                                id="mobile"
                                                maxlength="100"
                                                type="text"
                                                class="form-control"
                                                placeholder="ex: 9909237378"
                                                pmdTextField
                                                autocomplete="off"
                                                (keydown)="fPersonalInfo.mobile.disabled ?  $event.preventDefault() : ''">
                                        </pmd-textfield>
                                        <div *ngIf="sharedService.hasErrors(fPersonalInfo.mobile, isSubmitAttemptedForPersonalInfo)"
                                            class="invalid-feedback">
                                            <ng-container
                                                *ngIf="fPersonalInfo.mobile.errors.required || fPersonalInfo.mobile.errors.pattern">
                                                Enter a valid mobile number
                                            </ng-container>
                                        </div>
                                    </div>
                                </form>
                            </div>
                            <div class="personal-info-card"
                                *ngIf="currentStep == 2">
                                <form [formGroup]="companyInfoFormGroup">
                                    <div class="text-secondary-dark fw-bold">Step 2 of 2</div>
                                    <h4 class="text-dark">Company Info</h4>

                                    <div class="mb-3 mt-4">
                                        <label for="CompanyName"
                                            class="col-form-label">Company Name <strong class="text-danger">*</strong>
                                        </label>
                                        <pmd-textfield pmd-textfield-outline>
                                            <input name="CompanyName"
                                                formControlName="companyName"
                                                id="CompanyName"
                                                maxlength="100"
                                                type="text"
                                                class="form-control"
                                                placeholder="ex: Rich Elements Ltd"
                                                pmdTextField
                                                autocomplete="off">
                                        </pmd-textfield>
                                        <div *ngIf="sharedService.hasErrors(fCompanyInfo.companyName, isSubmitAttemptedForCompanyInfo)"
                                            class="text-danger">
                                            <div *ngIf="fCompanyInfo.companyName.errors.required">Company Name is
                                                required.
                                            </div>
                                            <div *ngIf="fCompanyInfo.companyName.errors.pattern">Invalid company name.
                                            </div>
                                        </div>
                                    </div>
                                    <div class="mb-3">
                                        <label for="GSTNumber"
                                            class="col-form-label">GST Number
                                        </label>
                                        <pmd-textfield pmd-textfield-outline>
                                            <input name="GSTNumber"
                                                formControlName="gst"
                                                id="GSTNumber"
                                                maxlength="100"
                                                type="text"
                                                class="form-control"
                                                pmdTextField
                                                placeholder="ex: 24BMDAM9828Z3Z1"
                                                autocomplete="off"
                                                (keyup)="onGSTAdd()"
                                                (change)="onGSTAdd()">
                                        </pmd-textfield>
                                        <div *ngIf="sharedService.hasErrors(fCompanyInfo.gst, isSubmitAttemptedForCompanyInfo)"
                                            class="text-danger">
                                            <div *ngIf="fCompanyInfo.gst.errors.pattern">Invalid GST Number.</div>
                                        </div>
                                    </div>
                                    <div class="mb-3">
                                        <label for="PAN"
                                            class="col-form-label">PAN <strong class="text-danger">*</strong>
                                        </label>
                                        <pmd-textfield pmd-textfield-outline>
                                            <input name="PAN"
                                                formControlName="pan"
                                                id="PAN"
                                                maxlength="100"
                                                type="text"
                                                class="form-control"
                                                placeholder="ex: MDAM9828Z"
                                                pmdTextField
                                                autocomplete="off">
                                        </pmd-textfield>
                                        <div *ngIf="sharedService.hasErrors(fCompanyInfo.pan, isSubmitAttemptedForCompanyInfo)"
                                            class="text-danger">
                                            <div *ngIf="fCompanyInfo.pan.errors.required">PAN is required.</div>
                                            <div *ngIf="fCompanyInfo.pan.errors.pattern">Invalid PAN.</div>
                                            <div *ngIf="fCompanyInfo.pan.errors?.PANNotMatching">PAN does not match with
                                                GST Number.</div>
                                        </div>
                                    </div>
                                </form>
                            </div>

                            <div class="d-flex gap-3 align-items-center mt-3"
                                [ngClass]="{'justify-content-between': currentStep !== 1,
                                            'justify-content-end': currentStep === 1 }">
                                <button type="button"
                                    pmdRipple
                                    *ngIf="currentStep !== 1 "
                                    pmd-btn-outline
                                    class="pmd-btn-min"
                                    color="dark"
                                    (click)="goToBackStep()">
                                    Back
                                </button>
                                <div class="d-flex gap-3">
                                    <button type="button"
                                        pmdRipple
                                        pmd-btn-raised
                                        class="pmd-btn-min"
                                        (click)="goToNextStep()"
                                        color="secondary">
                                        {{ currentStep !== 2 ? 'Next':'Submit'}}
                                        <span *ngIf="isSubmitting"
                                            class="spinner-border spinner-border-sm ms-1"
                                            role="status"
                                            aria-hidden="true"></span>
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>